import {InjectionToken, Type} from '@angular/core';
import {UserRole} from '../../../enums/user-role';
import {Point} from '../abstract-units';
import {SizesStandard} from '../sizes-standard';
import {WidgetImplementation} from './widget-implementation';
import {WidgetSettingsService} from './widget-settings-service';

export interface WidgetSettingsSchemaField {
    readonly name: string;
    readonly isShareable: boolean;
    readonly sharedName?: string;
}

export interface WidgetDescription {
    readonly widgetTypeId: string;
    readonly widgetLabel: string;
    readonly widgetImplementationType: Type<WidgetImplementation>;

    /**
     * It's not readable in order to allow set in the component's file,
     * and thus fix the complex circular dependency issue.
     */
    widgetComponentType: Type<any>;

    readonly widgetSettingsServiceType: Type<WidgetSettingsService>;
    readonly settingsSchema: WidgetSettingsSchemaField[];
    readonly hasGroupingSupport: boolean;
    readonly widgetSettingsComponentType: Type<any>;
    readonly defaultWidgetSize?: Point;
    readonly widgetSizes?: SizesStandard;

    /**
     * Filters users by role who can use this widget.
     */
    readonly userRoles?: UserRole[];
}

/**
 * Should be provided by {@link WidgetFactory}, allowing to inject it in implementations
 * without depending on {@link Widget} (which may ba a circular dependency).
 */
export const WIDGET_DESCRIPTION = new InjectionToken<WidgetDescription>('WidgetDescription');
